// Shared with Express via require(). Keep this module CommonJS.
const ODC_SPLITTER_OPTIONS = [[4, '۱:۴'], [8, '۱:۸'], [16, '۱:۱۶'], [32, '۱:۳۲']];
const LEAF_SPLITTER_OPTIONS = ODC_SPLITTER_OPTIONS.slice(0, 3);
const PATCH_PANEL_OPTIONS = [
  [24, '۲۴ کر - ۸ پورت'], [48, '۴۸ کر - ۱۶ پورت (پیش‌فرض)'], [96, '۹۶ کر - ۳۲ پورت'],
];
const FEEDER_CABLE_OPTIONS = [[48, '۴۸ کر'], [72, '۷۲ کر'], [96, '۹۶ کر']];
const FEEDER_CABLES_BY_DUCT = Object.assign(Object.create(null), { '8x5': [48], '14x10': [72, 96] });
const FAT_CABLE_OPTIONS = [[12, '۱۲ کر'], [24, '۲۴ کر'], [48, '۴۸ کر (پیش‌فرض)']];
const MICRODUCT_OPTIONS = [['14x10', '۱۴/۱۰'], ['8x5', '۸/۵']];
const DISTRIBUTION_OPTIONS = [['mixed', 'ترکیبی (ODC و MFAT)'], ['all_odc', 'تمام ODC (بدون MFAT)']];
const MAX_COMMON_SPLIT = 256;
const RADIUS = { min: 150, max: 1000, step: 50 };
// A null options entry denotes the numeric radius input.
const PARAM_FIELDS = [
  ['odc_serving_radius_m', 'شعاع سرویس‌دهی ODC (متر)', null],
  ['metro_microduct_type', 'میکروداکت مترو (۷ کاناله)', MICRODUCT_OPTIONS],
  ['odc_microduct_type', 'میکروداکت ODC (۷ کاناله)', MICRODUCT_OPTIONS],
  ['fat_microduct_type', 'میکروداکت FAT (۴ کاناله)', MICRODUCT_OPTIONS],
  ['mfat_enable', 'نقاط تقسیم', DISTRIBUTION_OPTIONS],
  ['odc_patch_panel_max_cores', 'پچ‌پنل ODC', PATCH_PANEL_OPTIONS],
  ['fat_per_port', 'اسپلیتر ODC', ODC_SPLITTER_OPTIONS],
  ['mfat_splitter', 'اسپلیتر MFAT', LEAF_SPLITTER_OPTIONS],
  ['fat_capacity', 'اسپلیتر FAT', LEAF_SPLITTER_OPTIONS],
  ['metro_cable_cores', 'فیبر مترو (رینگ)', FEEDER_CABLE_OPTIONS],
  ['odc_cable_cores', 'فیبر ODC', FEEDER_CABLE_OPTIONS],
  ['fat_cable_cores', 'فیبر لایه FAT', FAT_CABLE_OPTIONS],
];
const PROFILE_KEYS = PARAM_FIELDS.map(([key]) => key);
const PROFILE_DEFAULTS = { odc_serving_radius_m: 500, coverage_radius_m: 500,
  metro_microduct_type: '14x10', odc_microduct_type: '14x10', fat_microduct_type: '8x5',
  mfat_enable: true, odc_patch_panel_max_cores: 48, fat_per_port: 8, mfat_splitter: 8,
  fat_capacity: 8, metro_cable_cores: 96, odc_cable_cores: 72, fat_cable_cores: 48 };
const LIST_FIELDS = [
  ['fat_per_port', ODC_SPLITTER_OPTIONS, 'اسپلیتر ODC معتبر نیست.'],
  ['mfat_splitter', LEAF_SPLITTER_OPTIONS, 'اسپلیتر MFAT معتبر نیست.'],
  ['fat_capacity', LEAF_SPLITTER_OPTIONS, 'اسپلیتر FAT معتبر نیست.'],
  ['odc_patch_panel_max_cores', PATCH_PANEL_OPTIONS, 'پچ‌پنل ODC معتبر نیست.'],
  ['fat_cable_cores', FAT_CABLE_OPTIONS, 'فیبر لایه FAT معتبر نیست.'],
  ['metro_cable_cores', FEEDER_CABLE_OPTIONS, 'فیبر مترو معتبر نیست.'],
  ['odc_cable_cores', FEEDER_CABLE_OPTIONS, 'فیبر ODC معتبر نیست.'],
  ['metro_microduct_type', MICRODUCT_OPTIONS, 'میکروداکت مترو معتبر نیست.'],
  ['odc_microduct_type', MICRODUCT_OPTIONS, 'میکروداکت ODC معتبر نیست.'],
  ['fat_microduct_type', MICRODUCT_OPTIONS, 'میکروداکت FAT معتبر نیست.'],
];
function validateProfileParams(params) {
  const errors = [];
  const value = {};
  if (!params || typeof params !== 'object' || Array.isArray(params)) {
    return { ok: false, errors: [{ key: 'params', message: 'مقدارهای پروفایل معتبر نیستند.' }], value };
  }
  for (const key of PROFILE_KEYS) {
    const raw = params[key];
    value[key] = key.endsWith('_microduct_type') || key === 'mfat_enable' ? raw
      : (typeof raw === 'number' || (typeof raw === 'string' && raw.trim()) ? Number(raw) : NaN);
  }
  const radius = value.odc_serving_radius_m;
  if (!Number.isFinite(radius) || radius < RADIUS.min || radius > RADIUS.max || (radius - RADIUS.min) % RADIUS.step !== 0) {
    errors.push({ key: 'odc_serving_radius_m', message: 'شعاع باید بین ۱۵۰ و ۱۰۰۰ متر و مضربی از ۵۰ باشد.' });
  }
  for (const [key, options, message] of LIST_FIELDS) {
    if (!options.some(([v]) => v === value[key])) errors.push({ key, message });
  }
  if (typeof value.mfat_enable !== 'boolean') errors.push({ key: 'mfat_enable', message: 'نقاط تقسیم باید «ترکیبی» یا «تمام ODC» باشد.' });
  for (const [layer, label] of [['metro', 'مترو'], ['odc', 'ODC']]) {
    const key = `${layer}_cable_cores`;
    const duct = value[`${layer}_microduct_type`];
    if (FEEDER_CABLES_BY_DUCT[duct] && !FEEDER_CABLES_BY_DUCT[duct].includes(value[key])
      && FEEDER_CABLE_OPTIONS.some(([v]) => v === value[key])) {
      errors.push({ key, message: `فیبر ${label} با میکروداکت ${duct === '8x5' ? '۸/۵ باید ۴۸ کر باشد.' : '۱۴/۱۰ باید ۷۲ یا ۹۶ کر باشد.'}` });
    }
  }
  value.coverage_radius_m = radius;
  return { ok: errors.length === 0, errors, value };
}
// Project parameters are the preset keys plus the two geometry/radius aliases.
function validateProjectParams(params) {
  const invalid = (key, message) => ({ ok: false, errors: [{ key, message }], value: {} });
  if (!params || typeof params !== 'object' || Array.isArray(params)
      || ![Object.prototype, null].includes(Object.getPrototypeOf(params))) {
    return invalid('params', 'پارامترهای طرح معتبر نیستند.');
  }
  const allowed = new Set([...PROFILE_KEYS, 'coverage_radius_m', 'region_polygon']);
  for (const key of Object.keys(params)) {
    if (!allowed.has(key)) return invalid(key, `پارامتر «${key}» مجاز نیست.`);
  }
  const checked = validateProfileParams(params);
  if (!checked.ok) return checked;
  if (Object.hasOwn(params, 'coverage_radius_m')
      && Number(params.coverage_radius_m) !== checked.value.odc_serving_radius_m) {
    return invalid('coverage_radius_m', 'شعاع پوشش باید با شعاع سرویس‌دهی برابر باشد.');
  }
  if (Object.hasOwn(params, 'region_polygon')) {
    const ring = params.region_polygon;
    if (!Array.isArray(ring) || ring.length < 3 || ring.length > 2000
        || !ring.every((point) => Array.isArray(point) && point.length === 2
          && point.every(Number.isFinite) && Math.abs(point[0]) <= 180 && Math.abs(point[1]) <= 90)) {
      return invalid('region_polygon', 'محدودهٔ طرح معتبر نیست.');
    }
    checked.value.region_polygon = ring.map((point) => [...point]);
  }
  return checked;
}
// Interactive duct changes prefer the layer default, not the previous cable size.
function snapCables(params) {
  const value = Object.assign({}, params);
  for (const layer of ['metro', 'odc']) {
    const key = `${layer}_cable_cores`;
    const legal = FEEDER_CABLES_BY_DUCT[value[`${layer}_microduct_type`]];
    if (legal && !legal.includes(value[key])) {
      value[key] = legal.includes(PROFILE_DEFAULTS[key]) ? PROFILE_DEFAULTS[key] : legal[0];
    }
  }
  return value;
}
function normalizeProfileParams(raw = {}) {
  const value = Object.assign({}, PROFILE_DEFAULTS);
  for (const key of PROFILE_KEYS) if (Object.hasOwn(raw, key)) {
    value[key] = key.endsWith('_microduct_type') || key === 'mfat_enable' ? raw[key] : Number(raw[key]);
  }
  if (Object.hasOwn(raw, 'microduct_type')) {
    for (const layer of ['odc', 'fat']) if (!Object.hasOwn(raw, `${layer}_microduct_type`)) {
      value[`${layer}_microduct_type`] = raw.microduct_type;
    }
  }
  if (value.fat_capacity === 32) value.fat_capacity = 16;
  if (value.odc_patch_panel_max_cores === 72) value.odc_patch_panel_max_cores = 48;
  if (value.odc_patch_panel_max_cores === 128) value.odc_patch_panel_max_cores = 96;
  for (const layer of ['metro', 'odc']) {
    const key = `${layer}_cable_cores`;
    const legal = FEEDER_CABLES_BY_DUCT[value[`${layer}_microduct_type`]];
    const retired = layer === 'metro' ? [48, 72, 96, 144, 192] : [48, 72, 96];
    if (legal && !legal.includes(value[key]) && retired.includes(value[key])) {
      // Stored choices snap down to the nearest allowed choice, else the smallest.
      value[key] = Object.hasOwn(raw, key)
        ? (legal.filter((n) => n <= value[key]).pop() ?? legal[0])
        : (legal.includes(PROFILE_DEFAULTS[key]) ? PROFILE_DEFAULTS[key] : legal[0]);
    }
  }
  const checked = validateProfileParams(value);
  if (!checked.ok) throw new RangeError(checked.errors[0].message);
  return checked.value;
}
module.exports = { ODC_SPLITTER_OPTIONS, LEAF_SPLITTER_OPTIONS, PATCH_PANEL_OPTIONS,
  FEEDER_CABLE_OPTIONS, FEEDER_CABLES_BY_DUCT, FAT_CABLE_OPTIONS, MICRODUCT_OPTIONS,
  DISTRIBUTION_OPTIONS, MAX_COMMON_SPLIT, PROFILE_KEYS, PROFILE_DEFAULTS, PARAM_FIELDS,
  RADIUS, snapCables, normalizeProfileParams, validateProfileParams, validateProjectParams };
